var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 37.4989C111.328 36.3272 109.738 35.6689 108.081 35.6689C106.424 35.6689 104.834 36.3272 103.662 37.4989L74.9998 66.1614L46.3373 37.4989C45.1653 36.3272 43.5759 35.6689 41.9186 35.6689C40.2613 35.6689 38.6719 36.3272 37.4998 37.4989C36.3281 38.6709 35.6699 40.2603 35.6699 41.9176C35.6699 43.5749 36.3281 45.1643 37.4998 46.3364L66.1623 74.9989L37.4998 103.661C36.3281 104.833 35.6699 106.423 35.6699 108.08C35.6699 109.737 36.3281 111.327 37.4998 112.499C38.6719 113.671 40.2613 114.329 41.9186 114.329C43.5759 114.329 45.1653 113.671 46.3373 112.499L74.9998 83.8364L103.662 112.499C104.834 113.671 106.424 114.329 108.081 114.329C109.738 114.329 111.328 113.671 112.5 112.499C113.672 111.327 114.33 109.737 114.33 108.08C114.33 106.423 113.672 104.833 112.5 103.661L83.8373 74.9989L112.5 46.3364C113.672 45.1643 114.33 43.5749 114.33 41.9176C114.33 40.2603 113.672 38.6709 112.5 37.4989Z",
    fill: "#EF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4e9ba999426ad104c19053053693e6e5.svg";
export { ForwardRef as ReactComponent };